<template>
  <div class="text-center thank-you-message">{{this.$t("survey_save_success")}}</div>
</template>

<script>
export default {
    name: "ThankYouPage"
}
</script>

<style scoped>
.thank-you-message{
    font-size: 40px !important;
}

</style>